import {noop} from 'es-toolkit'

let didInteract = false
export const onInteract = (cb: () => void = noop) => {
  if (didInteract) {
    cb()
    return
  }

  const handleInteract = () => {
    if (didInteract) {
      return
    }

    didInteract = true

    cb()
    window.removeEventListener('touchstart', handleInteract, {capture: false})
    window.removeEventListener('click', handleInteract, false)
    window.removeEventListener('mousemove', handleInteract, false)
  }
  window.addEventListener('touchstart', handleInteract, {passive: true, capture: false})
  window.addEventListener('click', handleInteract, false)
  window.addEventListener('mousemove', handleInteract, false)
}

export const loadStyle = (src: string, cb: () => void = noop) => {
  const tag = document.createElement('link')
  tag.setAttribute('href', src)
  tag.setAttribute('type', 'text/css')
  tag.setAttribute('rel', 'stylesheet')
  tag.onload = cb
  tag.onerror = cb
  document.head.appendChild(tag)
}

export const loadScript = (src: string, cb: () => void = noop) => {
  const tag = document.createElement('script')
  tag.setAttribute('src', src)
  tag.setAttribute('async', 'async')
  tag.onload = cb
  tag.onerror = cb
  document.head.appendChild(tag)
}

export const waitForApi = (
  test: () => boolean,
  cb: () => void,
  abortCb = noop,
  interval = 1000,
  maxRetries = 10
) => {
  if (test()) {
    cb()
  } else if (maxRetries > 0) {
    setTimeout(() => waitForApi(test, cb, abortCb, interval, maxRetries - 1), interval)
  } else {
    abortCb()
  }
}
